import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TitleDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent implements OnChanges {
  titleForm: FormGroup;
  titleFormArray: FormGroup;
  control = new FormControl();
  @Input() titles: TitleDto[];
  @Input() routeAnimationsElements: any;
  @Output() title = new EventEmitter<TitleDto[]>();
  @Output() deleteTitleEvent = new EventEmitter<any>();

  selectedTitle: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createTitleForm();
  }

  createTitleForm() {
    this.titleForm = this.fb.group({
      TitleName: ['', Validators.required],
      id: null,
    });
    this.titleFormArray = this.fb.group({ Titles: this.fb.array([]) });
    this.setTitle();
  }

  // method to display titles
  setTitle() {
    const control = this.titleFormArray.controls.Titles as FormArray;
    this.titles.forEach((e) => {
      control.push(
        this.fb.group({
          TitleName: e.TitleName,
          id: e.id,
        })
      );
    });
  }

  // method to add Title
  addTitle(value: TitleDto) {
    const control = this.titleFormArray.controls.Titles as FormArray;
    control.insert(
      0,
      this.fb.group({
        TitleName: value.TitleName,
        id: null,
      })
    );
  }

  selectTitle(value) {}

  // method to delete title from arrary list
  deleteTitle(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.titleFormArray.controls.Titles as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.titles.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.titles[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: TitleDto) {
    if (this.titleForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.titleFormArray
        .get('Titles')
        ['controls'][this.selectedIndex].patchValue({
          TitleName: formValue.TitleName,
        });
    } else {
      this.addTitle(formValue);
    }
    this.selectedIndex = null;
    this.titleForm.reset();
  }

  onEdit(index, value: TitleDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.titleForm.patchValue({ TitleName: value.TitleName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.titleForm.reset();
  }

  onSubmit(formValue: TitleDto[]) {
    this.title.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteTitleEvent.emit(this.filteredDelete);
    }
  }
}
